import React, { useState } from 'react';
import { Link, NavLink } from 'react-router-dom';
import './Header.css';
import logo from '../assets/logo.png';
import { FaBars, FaTimes } from 'react-icons/fa';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <header className="site-header">
      <Link to="/" className="logo-link">
        <img src={logo} alt="Aeti Cleaning Services logo" className="logo" />
        <div>
          <span className="brand-name">Aeti Cleaning Services</span>
          <span className="brand-tag">A friend you can count on</span>
        </div>
      </Link>

      <div className="burger-icon" onClick={toggleMenu}>
        {isMenuOpen ? <FaTimes /> : <FaBars />}
      </div>

      <nav className={isMenuOpen ? 'nav-open' : ''}>
        <NavLink
          to="/"
          end
          className={({ isActive }) => (isActive ? 'active' : '')}
          onClick={() => {
            setIsMenuOpen(false);
            // NavLink to the route you're already on doesn't trigger a navigation/remount, so
            // without this, clicking "Home" while scrolled down leaves the scroll position
            // wherever it was instead of returning to the hero.
            window.scrollTo({ top: 0, behavior: 'smooth' });
          }}
        >
          Home
        </NavLink>
        <NavLink to="/services" className={({ isActive }) => (isActive ? 'active' : '')} onClick={() => setIsMenuOpen(false)}>Our Services</NavLink>
        <NavLink to="/cleaning-process" className={({ isActive }) => (isActive ? 'active' : '')} onClick={() => setIsMenuOpen(false)}>Aeti Process</NavLink>
        <NavLink to="/about" className={({ isActive }) => (isActive ? 'active' : '')} onClick={() => setIsMenuOpen(false)}>About Us</NavLink>
        <NavLink to="/contact" className={({ isActive }) => (isActive ? 'active' : '')} onClick={() => setIsMenuOpen(false)}>Contact Us</NavLink>
      </nav>
    </header>
  );
};

export default Header;
